import { FC, PropsWithChildren, useEffect } from "react"
import appConfig from "../app-config"
import AppStart from "@hornet-web-react/core/components/Utils/AppStart"
import { UseAppStartEmitter } from "@hornet-web-react/core/hooks/use-app-start"
import {
  useSessionDevice,
  useSessionUser,
} from "@hornet-web-react/core/contexts/session"
import { useRouter } from "next/router"
import EventTrackerService from "@hornet-web-react/core/services/EventTrackerService"
import { useCoreService } from "@hornet-web-react/core/contexts/services"
import { CORE_TYPES } from "@hornet-web-react/core/services/types"
import { TrackEventParams } from "@hornet-web-react/core/models/track-event"
import anonLatLng from "@hornet-web-react/core/utils/anon-lat-lng"

type HornetAppStartProps = PropsWithChildren

const HornetAppStart: FC<HornetAppStartProps> = ({ children }) => {
  const eventTrackerService = useCoreService<EventTrackerService>(
    CORE_TYPES.EventTrackerService
  )

  const { deviceLocation } = useSessionDevice()
  const { currentUser } = useSessionUser()
  const router = useRouter()

  useEffect(() => {
    const changeAppStartDoneChangedHandler = (appStartDone: boolean) => {
      if (appStartDone) {
        let extraParams: TrackEventParams | undefined

        if (deviceLocation) {
          const anonDeviceLocation = anonLatLng(deviceLocation)

          if (anonDeviceLocation) {
            extraParams = [
              {
                key: "latlng",
                string_value: anonDeviceLocation,
              },
            ]
          }
        }

        void eventTrackerService.reportPageLoadedOnce(
          router.pathname,
          !!currentUser?.hasPremium,
          extraParams
        )
      }
    }

    UseAppStartEmitter.on(
      "appStartDoneChanged",
      changeAppStartDoneChangedHandler
    )

    return () => {
      UseAppStartEmitter.off(
        "appStartDoneChanged",
        changeAppStartDoneChangedHandler
      )
    }
  }, [currentUser, deviceLocation, eventTrackerService, router.pathname])

  return (
    <AppStart appConfig={appConfig} hasServiceWorker={false}>
      {children}
    </AppStart>
  )
}

export default HornetAppStart
